export default "__VITE_ASSET__wZpgVO8e__"